/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Bigsley = {
    // All pages
    'common': {
      init: function() {
    	  //nav
    	  $("#mobile-menu").on("click", function() {
    		  $(".nav-primary").slideToggle(400);
    		  $(".menu-main-menu").delay(400).fadeToggle(200);
    	  });
    	  
    	  $(document).on("click", function(){
          $("#international-select-button").removeClass("international-select-active");
          $("#menu-international").slideUp(400);
        });

        $("#international-select-button").on("click", function(e) {
          $(this).toggleClass("international-select-active");
          $("#menu-international").slideToggle(400);
          e.stopPropagation();
        });
    	  
    	  function menuItemChildren(obj) {
    		  var activeMenuClass = "sub-menu-active";
    		  if($(obj).hasClass(activeMenuClass)) {
    			  $(obj).find("ul.sub-menu").slideUp(200);
    			  $(obj).removeClass(activeMenuClass);
    		  } else {
    			  $(obj).find("ul.sub-menu").slideDown(400);
    			  $(obj).addClass(activeMenuClass);
    		  }
    	  }
    	  $(".nav .menu-item-has-children a").on("click", function(e) {
    		  //e.preventDefault();
    	  });
    	  $(".nav .menu-item-has-children").hover(function(){menuItemChildren(this);}, function(){menuItemChildren(this);});

    	  //modal close
    	  $("#modal-header-close").on("click", function() {
			    $("#galleryModal").modal("hide");
    	  });

    	  //footer-scroll-top
    	  $("#footer-scroll-top").on("click", function() {
    		  $("html, body").animate({ scrollTop: "0" }, 800);
    	  });
    	  
    	  //parallax
    	  $(window).enllax();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
         $(document).ready(function(e){
            jQuery('#DesktopSlider, #MobileSlider').bxSlider({
               pager: false,
               auto: true,
               pause: 8000,
               onSlideAfter: function (elem, oldIndex, newIndex) {
                  if (window.console)
                  {
                     var key = $(elem).attr('datakey');
                     sendAnalytics(key, 'Slider Impression', key+' Slider Impression', 1);
                  }
               }
            });
         });
        
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // Home page
    'movement': {
      init: function() {
        // JavaScript to be fired on the home page
		  $(document).ready(function(e){
			  jQuery('#DesktopSlider, #MobileSlider').bxSlider({pager: false, auto: true});
		  });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about': {
      init: function() {
    	  $(".our-history-block-wrapper").on("click", function() {
    		 $(".our-history-block-wrapper").removeClass("our-history-active");
    		 $(this).addClass("our-history-active");
    	  });
      }
    },
    'gallery': {
        init: function() {
			
			// var slideBlockWidth = 282;
			// var left = 0;
			// var sliderWidth = 0;
			// function initGallerySlider() {
				// var slides = $("#gallery-video-slider").children().length;
				// sliderWidth = slideBlockWidth * slides;
				// $("#gallery-video-slider").width(sliderWidth);
			// }
			// initGallerySlider();
			// function setGalleryLeft(left) {
				// $("#gallery-video-slider").css("left", left);
			// }
			// $("#gallery-video-button-left").on("click", function() {
				// left = left - slideBlockWidth;
				// setGalleryLeft(left);
			// });
			// $("#gallery-video-button-right").on("click", function() {
				// left = left + slideBlockWidth;
				// setGalleryLeft(left);
			// });
			// $(".gallery-video").on("click", function() {
				// var iframeSrc = $(this).data("vmodal");
				// if(iframeSrc === undefined) {
					// $("#modal-body").html("<h2>Video Not Found</h2>");
				// } else {
					// $("#modal-body").html("<iframe class='modal-iframe' src='" + iframeSrc + "'></iframe>");
				// }
				// $("#galleryModal").modal("show");
			// });
			
			// $("#gallery-images").on("click", "img", function() {
				// var imageSrc = $(this).data("imodal");
				// var width = $(this).data("iwidth");
				// var height = $(this).data("iheight");
				// if(imageSrc === undefined) {
					// $("#modal-body").html("<h2>Video Not Found</h2>");
				// } else {
					// $("#modal-body").html("<img style='max-width: " + width + "px; max-height: " + height + "px;' class='modal-image' src='" + imageSrc + "' />");
				// }
				// $("#galleryModal").modal("show");
			// });
			
			
			// var data = {
			        // 'action': 'gallery_query_images',
			        // 'post_type': 'post',
			        // 'tag': "gallery",
			        // 'offset': 0,
              // 'triggeredBy': 'onPageLoad'
			    // };
			// var ajax_url = "http://localhost:8080/color-run/wp-admin/admin-ajax.php?g=" + Date.now();
			// var replace = false;
			// var offset = 0;
			// var loadImageCount = 12;
			
			// function appendImages(images) { 

				// //clear the gallery if user clicked the view photos by city dropdown menu
				// if(replace === true) {
				  // $('#temporary-gallery-images').html('');
				  // $("#gallery-images").html('');
				// }

				// //append the images to the gallery
				// for(var img = 0; img < images.length; img++) {
					// imageData = "<div class='grid-item' data-category='"+images[img].category+"'><img src='" + images[img].url + "' data-imodal='" + images[img].url + "' data-iheight='" + images[img].height + "' data-iwidth='" + images[img].width + "'/></div>";	
					// $('#temporary-gallery-images').append(imageData);
					// $("#gallery-images").append(imageData);
					// $('#event-gallery-images').append(imageData);
				// }

				// replace = false;   
				// //wait for the images to load then reinitialize mansory     
				// // $('.grid').imagesLoaded( function(e) {
				  // // if(typeof $grid === 'undefined') {            
				  // // $grid = $('.grid').masonry({
					// // itemSelector: '.grid-item',
					// // });
				  // // } else {
					// // $grid.masonry('destroy');
					// // $grid = $('.grid').masonry({
					  // // itemSelector: '.grid-item',
					// // });
				  // // }
				// // });
			// }

      //send ajax request to fetch photos
	    // function queryImages() {	    
        // $.ajax({
          // url: ajax_url,
		  // data: data,
          // method: "POST",
          // dataType: 'json'

        // }).done(function(response){
          // $("#query-message").html('');
          // if(response.status == false) {            
            // $("#query-message").html("<h1>" + response.message + "</h1>");
          // } else {
          
		  // alert('tes');
          // }          
          
        // }).fail(function(){
          // $("#gallery-message").html("<h1>Server Error.</h1>");
        // });
	    // }

	   // queryImages();

	    // attach event handler when user click view photos by city
	    $("#gallery-city-dropdown li").on("click", function() {
	    	data.tag = $(this).data("city");
	    	replace = true;
	    	offset = 0;
	    	data.offset = offset;
	    	//queryImages();
	    });
		
		$("#gallery-city-button").on("click", function() {
			$(this).toggleClass("gallery-city-button-active");
			$("#gallery-city-dropdown").slideToggle(400);
		});

      //attach handler when user click see more
	    // $("#gallery-see-more").on("click", function(e) {
        // e.preventDefault();
	    	// offset = offset + loadImageCount;
	    	// data.offset = offset;
        // data.triggeredBy = 'see-more';
	    	// //queryImages();
	    // });

      // attach handler when user wanted to filter photos by nigt events or internationl
      // $('#events-night-filter, #events-international-filter').on('click', function(e){
        // e.preventDefault();
        // if($(this).attr('id') == 'events-night-filter') {
          // filterGridImagesBy('color_run_night');                   
        // } 

        // if($(this).attr('id') == 'events-international-filter') {
          // filterGridImagesBy('international');         
        // } 
      // });
		
      // function filterGridImagesBy(paramCategory) {
        // // $('#gallery-images').html('').append($('#temporary-gallery-images').html());

        // // // wait for the images to load completely
        // // $('.grid').imagesLoaded( function() {
          // // masonryInit();

          // // $('.grid-item').each(function(){     
            // // var gridItem = this;     
            // // var category = $(this).data('category');            
            // // if(category !== paramCategory) {
              // // removeGridItem(gridItem);
            // // }            
          // // }); 
        // // });        
      // }

      // function removeGridItem(gridItem) {
        // $grid.masonry( 'remove', gridItem )
        // .masonry('layout');
      // }

      // function masonryInit(){   
        // var $grid = $('.grid');
        // $grid.height( $grid.height() );
        // if(typeof $grid === 'undefined') {            
          // $grid = $('.grid').masonry({
            // itemSelector: '.grid-item',
          // });
        // } else {
          // $grid.masonry('destroy');
          // $grid = $('.grid').masonry({
            // itemSelector: '.grid-item',
          // });
        // }       
      // }

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Bigsley;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  
  $('.carousel[data-type="multi"] .item').each(function(){
    var next = $(this).next();
    if (!next.length) {
      next = $(this).siblings(':first');
    }
    next.children(':first-child').clone().appendTo($(this));

    for (var i=0;i<2;i++) {
      next=next.next();
    if (!next.length) {
      next = $(this).siblings(':first');
    }

      next.children(':first-child').clone().appendTo($(this));
    }
  });

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

